import { useState } from "react";

import "./styles.scss";

const SegmentedControl = ({
  options = [],
  value, // Dışarıdan gelen seçili ID
  onChange, // Değişikliği bildiren fonksiyon
  defaultValue, // Opsiyonel başlangıç değeri
  isEqualWidth = true, // TRUE: Eşit bölüştür, FALSE: İçeriğe göre
  className = "",
}) => {
  // İç state: Sadece dışarıdan value gelmiyorsa kullanılır
  const [internalValue, setInternalValue] = useState(defaultValue || options[0]?.id);

  // Aktif olan değeri belirle (Controlled vs Uncontrolled)
  const activeId = value !== undefined ? value : internalValue;

  const handleSelect = (id) => {
    if (value === undefined) {
      setInternalValue(id);
    }
    if (onChange) {
      onChange(id);
    }
  };

  return (
    <div
      className={`
      segmented-control 
      ${isEqualWidth ? "--equal-width" : "--proportional-width"} 
      ${className}
    `}>
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          className={`segmented-item ${activeId === option.id ? "--active" : ""}`}
          onClick={() => handleSelect(option.id)}>
          {option.renderIcon && (
            <span className="item-icon">{option.renderIcon(activeId === option.id)}</span>
          )}
          <span className="item-text">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl;
